import $ from "jquery";

const coursesFilter = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        $(() => {
            const btns = $('.mi-courses__filter-btn');
            const cards = $('.mi-courses__list-card');

            btns.on('click', function () {
                const category = $(this).data('category');

                // update active button
                btns.removeClass('active');
                $(this).addClass('active');

                if (category === 'all') {
                    cards.parent().show();
                } else {
                    cards.each(function () {
                        const cardCats = $(this).data('cat').split(' ');
                        if (cardCats.includes(category)) {
                            $(this).parent().show();
                        } else {
                            $(this).parent().hide();
                        }
                    });
                }
            });
        });
    };

    init();
};

try {
    coursesFilter();
} catch (error) {
    console.error("coursesFilter", error);
}